import { createContext, FC, ReactElement, useContext, useMemo } from 'react'
import { getAppDomain } from 'src/helpers/runtime'

interface DomainContextType {
  isBuzz: boolean
  isPayReady: boolean
}

const DomainContext = createContext<DomainContextType>({
  isBuzz: true,
  isPayReady: false,
})

export const useDomain = () => useContext(DomainContext)

export const DomainProvider: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const values = useMemo(() => {
    const { isPayReady, isBuzz } = getAppDomain()

    return {
      isBuzz,
      isPayReady,
    }
  }, [])

  return (
    <DomainContext.Provider value={values}>{children}</DomainContext.Provider>
  )
}
